// import logo from './assets/images/resources/logo.png';
// import './App.css';
import './css/style.css';
import './css/responsive.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'lenis/dist/lenis.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Routers from './routers';

function App() {
  return (
    <div className="App">
       <Routers/>
    </div>
  );
}

export default App;
